import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@wds/box';
import SkeletonLoader from '@sm/webassets/dist/components/SkeletonLoader';
const ThemesSkeleton = () => _jsx(Box, {
  display: "flex",
  flexJustify: "center",
  children: _jsx(Box, {
    m: 4,
    children: _jsxs(SkeletonLoader, {
      "data-testid": "ThemesSkeleton",
      height: 200,
      width: 180,
      children: [_jsx("rect", {
        x: "0",
        y: "0",
        rx: "0",
        ry: "0",
        width: "170",
        height: "30"
      }), _jsx("rect", {
        x: "0",
        y: "50",
        rx: "0",
        ry: "0",
        width: "170",
        height: "30"
      }), _jsx("rect", {
        x: "0",
        y: "100",
        rx: "0",
        ry: "0",
        width: "170",
        height: "30"
      }), _jsx("rect", {
        x: "0",
        y: "150",
        rx: "0",
        ry: "0",
        width: "170",
        height: "30"
      })]
    })
  })
});
export default ThemesSkeleton;